import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import * as ActionTypes from '../actions/types';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import {
    fetchDocumentTypesFailedAction,
    fetchDocumentTypesSuccessAction,
} from '../actions/documentType';
type State = {
    documentType:
        | {
              byId: { [id: string]: any } | {};
              allIds: Array<string | any>;
          }
        | any;
    loading: boolean;
    errorMessage: null | Array<string> | any;
};
const INITIAL_STATE = {
    documentType: {
        byId: {},
        allIds: [],
    },
    loading: false,
    errorMessage: null,
};

const fetchDocumentTypes = (state: State) => {
    return {
        ...state,
        loading: true,
    };
};

const fetchDocumentTypesSuccess = (
    state: State,
    action: PayloadAction<fetchDocumentTypesSuccessAction>,
) => {
    const { byId, allIds } = GENERAL_FUNCTIONS.normalizeById(
        'id',
        action.payload.body.data,
    );

    return {
        ...state,
        loading: false,
        documentType: {
            ...state.documentType,
            byId: byId,
            allIds: allIds,
        },
    };
};

const fetchDocumentTypesFailed = (
    state: State,
    action: PayloadAction<fetchDocumentTypesFailedAction>,
): State => {
    return {
        ...state,
        errorMessage: action.payload.body,
        loading: false,
    };
};

const documentType = createReducer(INITIAL_STATE, {
    [ActionTypes.FETCH_DOCUMENT_TYPES]: fetchDocumentTypes,
    [ActionTypes.FETCH_DOCUMENT_TYPES_SUCCESS]: fetchDocumentTypesSuccess,
    [ActionTypes.FETCH_DOCUMENT_TYPES_FAILED]: fetchDocumentTypesFailed,
});

export default documentType;
